import { render, staticRenderFns } from "./TagsDropdown.vue?vue&type=template&id=100f8f40&scoped=true&"
import script from "./TagsDropdown.vue?vue&type=script&lang=js&"
export * from "./TagsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TagsDropdown.vue?vue&type=style&index=0&id=100f8f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100f8f40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
